const serviciosNavTheme = {
    primary: "#3f3f46",
    primaryDark: "#18181b",
    primaryLight: "#d4d4d8",
    pale: "#f4f4f5",
};

export default serviciosNavTheme;
